import { ArrowUpRight } from "lucide-react";
import { projects } from "../content";
import { scrollToId } from "../lib/scroll";
import { Reveal } from "./Reveal";

const ProjectCard = ({ project, index }) => {
  const reversed = index % 2 === 1;
  return (
    <Reveal delay={0.05}>
      <article
        data-testid={`project-card-${project.id}`}
        className="group grid overflow-hidden rounded-[2rem] border border-black/10 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-transform duration-500 hover:-translate-y-1 md:grid-cols-12"
      >
        <div className={`relative aspect-[16/10] overflow-hidden md:col-span-7 ${reversed ? "md:order-2" : ""}`}>
          <img
            src={project.image}
            alt={project.alt}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
          />
          <span className="absolute left-5 top-5 rounded-full border border-white/25 bg-black/45 px-3 py-1 font-mono text-[9px] uppercase tracking-[0.2em] text-white/85 backdrop-blur">
            {project.category}
          </span>
        </div>
        <div className="flex flex-col p-8 md:col-span-5 md:p-10">
          <div className="flex items-center justify-between">
            <span className="font-mono text-xs tracking-[0.2em] text-black/40">{project.number}</span>
            <button
              type="button"
              data-testid={`project-cta-${project.id}`}
              onClick={() => scrollToId("contato")}
              aria-label={`Quero algo como ${project.title} — ir para contato`}
              className="grid h-10 w-10 place-items-center rounded-full border border-black/15 text-black/60 transition-colors duration-300 hover:border-[#1D4E89] hover:bg-[#1D4E89] hover:text-white"
            >
              <ArrowUpRight size={16} />
            </button>
          </div>
          <h3 className="mt-10 font-display text-3xl font-extrabold leading-[1.02] tracking-tighter text-[#1A1A1A] md:mt-14 md:text-4xl">
            {project.title}
          </h3>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-black/60 md:text-base">{project.description}</p>
          <span className="mt-6 w-fit rounded-full bg-black px-3 py-1 font-mono text-[10px] uppercase tracking-[0.16em] text-white">
            {project.category}
          </span>
        </div>
      </article>
    </Reveal>
  );
};

export const Projects = () => (
  <section id="projetos" className="scroll-mt-20 bg-[#F7F7F5] py-24 md:py-36" data-testid="projects-section">
    <div className="mx-auto max-w-7xl px-6">
      <div className="grid gap-10 md:grid-cols-12 md:items-end">
        <div className="md:col-span-7">
          <Reveal>
            <span className="rounded-full bg-black px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-white">
              Projetos selecionados
            </span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-display text-4xl font-extrabold leading-[0.98] tracking-tighter text-[#1A1A1A] sm:text-5xl lg:text-6xl">
              Tecnologia complexa,
              <br />
              histórias simples.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.14} className="md:col-span-5">
          <p className="rounded-3xl border border-black/10 bg-[#F2F2EF] p-6 text-sm leading-relaxed text-black/70">
            Uma seleção de formatos que eu crio: lançamentos, narrativas visuais e experiências interativas. Cada projeto é
            construído para ser fácil de entender e difícil de esquecer.
          </p>
        </Reveal>
      </div>
      <div className="mt-16 space-y-8 md:space-y-12">
        {projects.map((project, i) => (
          <ProjectCard key={project.id} project={project} index={i} />
        ))}
      </div>
    </div>
  </section>
);
